import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import AdminManager from './components/AdminManager';
import AdminDashboard from './components/AdminDashboard';
// import Navbar from './components/Navbar';
import ConditionalNavbar from './components/ConditionalNavbar';
import Home from './components/Home';
import Research from './components/Research';
import Publications from './components/Publications';
import Media from './components/Media';
import ContactUs from './components/ContactUs';
import Faq from './components/Faq';
import OurTeam from './components/OurTeam';
import Opportunities from './components/Opportunities';
import MediaEnquiries from './components/MediaEnquiries';
import Books from './components/Books';
import BooksScience from './components/BooksScience';
import BooksAbout from './components/BooksAbout';
import EverydayLapses from "./components/EverydayLapses";
import ADHD from "./components/ADHD";
import Concussion from './components/Concussion';
import Dementia from './components/Dementia';
import ParkinsonsDisease from './components/ParkinsonsDisease';
import AgingSuccessfully from './components/AgingSuccessfully';
import YourBrainOnAI from './components/YourBrainOnAI';
import Sleep from './components/Sleep';
import YourIQ from './components/YourIQ';
import MemoryChampion from './components/MemoryChampion';
import EmotionalRegulation from './components/EmotionalRegulation';
import BooksExtract from './components/BooksExtract';
import BooksContact from "./components/BooksContact";
import BooksNews from "./components/BooksNews";


// Import Admin Pages
import AdminHome from './components/admin/AdminHome';
import AdminNewsMedia from './components/admin/AdminNewsMedia';
import AdminResearch from './components/admin/AdminResearch';
import AdminPublications from './components/admin/AdminPublications';
import AdminTeam from './components/admin/AdminTeam';
import AdminOpportunities from './components/admin/AdminOpportunities';
import Login from './components/Login';
import AdminBooksNews from "./components/admin/AdminBooksNews";

import PrivateRoute from './components/PrivateRoute';
// import BooksExtract from './components/BooksExtract';



function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Router>
          {/* <Navbar /> */}
          <ConditionalNavbar />
          <Routes>

            {/* Public Routes */}
            <Route path='/' element={<Home />} />
            {/* <Route path='/admin' element={<AdminDashboard />} /> */}

            <Route path='/Research' element={<Research />} />
            <Route path='/Publications' element={<Publications />} />
            <Route path='/Media' element={<Media />} />
            <Route path='/ContactUs' element={<ContactUs />} />
            <Route path='Faq' element={<Faq />} />
            <Route path='/OurTeam' element={<OurTeam />} />
            <Route path='/Opportunities' element={<Opportunities />} />
            <Route path='/MediaEnquiries' element={<MediaEnquiries />} />
            <Route path='/admin/login' element={<Login />} />
            <Route path='/books' element={<Books />} />
            <Route path='/books/science' element={<BooksScience />} />
            <Route path="/books/about" element={<BooksAbout />} />
            <Route path='/books/science/everyday-lapses' element={<EverydayLapses />} />
            <Route path='/books/science/adhd' element={<ADHD />} />
            <Route path='/books/science/concussion' element={<Concussion />} />
            <Route path='/books/science/dementia' element={<Dementia />} />
            <Route path='/books/science/parkinsons-disease' element={<ParkinsonsDisease />} />
            <Route path='/books/science/aging-successfully' element={<AgingSuccessfully />} />
            <Route path='/books/science/your-brain-on-ai' element={<YourBrainOnAI />} />
            <Route path='/books/science/sleep' element={<Sleep />} />
            <Route path='/books/science/your-iq' element={<YourIQ />} />
            <Route path='/books/science/memory-champion' element={<MemoryChampion />} />
            <Route path='/books/science/emotional-regulation' element={<EmotionalRegulation />} />
            <Route path='/books/extract' element={<BooksExtract />} />
            <Route path="/books/contact" element={<BooksContact />} />
            <Route path="/books/news" element={<BooksNews />} />

            {/* <Route path='/admin' element={<AdminManager />} /> */}

            {/* Admin Routes */}
            {/* <Route path='/admin/home' element={<AdminHome />} />
            <Route path='/admin/news-media' element={<AdminNewsMedia />} />
            <Route path='/admin/research' element={<AdminResearch />} />
            <Route path='/admin/publications' element={<AdminPublications />} />
            <Route path='/admin/team' element={<AdminTeam />} />
            <Route path='/admin/opportunities' element={<AdminOpportunities />} />
            <Route path='/admin/login' element={<Login />} /> */}
            {/* <Route path='/admin/*' element={<AdminDashboard />} /> */}
            <Route
              path='/admin/home'
              element={
                <PrivateRoute>
                  <AdminHome />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/news-media'
              element={
                <PrivateRoute>
                  <AdminNewsMedia />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/research'
              element={
                <PrivateRoute>
                  <AdminResearch />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/publications'
              element={
                <PrivateRoute>
                  <AdminPublications />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/team'
              element={
                <PrivateRoute>
                  <AdminTeam />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/opportunities'
              element={
                <PrivateRoute>
                  <AdminOpportunities />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin'
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/books-news"
              element={
                <PrivateRoute>
                  <AdminBooksNews />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
